import React from 'react';
import { Rater, RaterNoteData } from '../../../types/rater';
import { Group, List, Stack, Text } from '@mantine/core';
import Paragraph from '../../elements/Paragraph';

interface FooterProps {
  data: Rater[];
  notes?: RaterNoteData[];
  notesExpectation?: any;
  type?: 'rater' | 'expectation';
}

const Footer: React.FC<FooterProps> = ({
  data,
  type,
  notes,
  notesExpectation
}) => {
  const sumScoreRater = data.reduce((sum, item) => sum + item.scoreRater, 0);
  const sumScoreExpectation = data.reduce(
    (sum, item) => sum + item.scoreExpectation,
    0
  );

  return (
    <>
      <div className="footer-table-method">
        <div className="footer-table-method__grand-total">
          <p className="m-0">Total Score</p>
        </div>
        <div className="footer-table-method__score">
          <p className="m-0">{sumScoreExpectation}</p>
        </div>
        {type === 'rater' && (
          <div className="footer-table-method__score">
            <p className="m-0">{sumScoreRater}</p>
          </div>
        )}
      </div>
      {/* {type === 'expectation' && ( */}
      {notesExpectation === null ? null : (
        <Stack p={12} gap={8}>
          <Text className="text-xs-bold">Notes Expectation:</Text>
          {notesExpectation?.length === 0 ||
            (notesExpectation === null && (
              <Text className="text-xs-medium" fs={'italic'}>
                No notes available
              </Text>
            ))}

          {notesExpectation?.length > 0 && (
            <List>
              {notesExpectation.map((note, index) => {
                if (note?.notes && note?.notes !== ' ') {
                  return (
                    <List.Item
                      key={`${note?.jenis}-${index}`}
                      className="text-xs-medium"
                      style={{ whiteSpace: 'pre-wrap' }}
                    >
                      {note?.notes === '' ? (
                        'No notes'
                      ) : (
                        <Paragraph text={note?.notes} />
                      )}
                    </List.Item>
                  );
                }
                return false;
              })}
            </List>
          )}
        </Stack>
      )}

      <Stack p={12} gap={8}>
        <Text className="text-xs-bold">Notes:</Text>
        {notes?.length === 0 && (
          <Text className="text-xs-medium" fs={'italic'}>
            No notes available
          </Text>
        )}

        {notes?.length > 0 && (
          <List>
            {notes.map((note, index) => {
              if (note?.notes && note?.notes !== ' ') {
                return (
                  <List.Item
                    key={`${note?.jenis}-${index}`}
                    className="text-xs-medium"
                    style={{ whiteSpace: 'pre-wrap' }}
                  >
                    {note?.notes === '' ? (
                      'No notes'
                    ) : (
                      <Paragraph text={note?.notes} />
                    )}
                  </List.Item>
                );
              }
              return false;
            })}
          </List>
        )}
      </Stack>

      {/* )} */}
    </>
  );
};

export default Footer;
